import api from "@/router/api";
import apiPublic from "@/router/apiPublic";
import userInfos from "@/utils/userInfos";

const coordenadorCache = new Map();

export default {
  async getAllAcoes(page, size) {
    const response = await api.get("/acoes", {
      params: { page, size },
    });
    return response.data.content || response.data;
  },

  async getAcoesFiltro(
    page = 0,
    size = 10,
    unidadeId = null,
    status = null,
    busca = null
  ) {
    const params = { page, size };
    if (unidadeId) params.unidadeId = unidadeId;
    if (status) params.status = status;
    if (busca) params.busca = busca;

    const response = await api.get("/acoes/filtro", { params });
    return response.data;
  },

  async getAcoesById(acaoId) {
    const response = await apiPublic.get(`/acoes/${acaoId}`);
    return response.data;
  },

  async getAcoesByTitulo(titulo) {
    const response = await api.get("/acoes/busca", {
      params: { titulo },
    });
    return response.data;
  },

  async getMembrosTime(acaoId) {
    const response = await api.get(`/acoes/membros-time/${acaoId}`);
    return response.data;
  },

  async postAcoes(dadosAcao) {
    const response = await api.post("/acoes/salvar-csv", dadosAcao);
    return response.data;
  },

  verificarCoordenador(acaoId) {
    if (!acaoId) return Promise.resolve(false);

    const user = userInfos.getUserInfos();
    const token = window.localStorage.getItem("auth_token");
    if (!user || !user.userId || !token || userInfos.tokenExpirado(user)) {
      return Promise.resolve(false);
    }

    const cacheKey = `${user.userId}_${acaoId}`;
    if (coordenadorCache.has(cacheKey)) {
      return coordenadorCache.get(cacheKey);
    }

    const request = api
      .get(`/acoes/${acaoId}/verificar-coordenador`)
      .then((response) => response.data)
      .catch((error) => {
        coordenadorCache.delete(cacheKey);
        return false;
      });

    coordenadorCache.set(cacheKey, request);
    return request;
  },

  limparCacheCoordenador(acaoId) {
    if (acaoId) {
      const user = userInfos.getUserInfos();
      const userId = user?.userId || "anon";
      coordenadorCache.delete(`${userId}_${acaoId}`);
    } else {
      coordenadorCache.clear();
    }
  },

  async editarSigla(acaoId, sigla, corSigla) {
    const response = await api.put(`/acoes/${acaoId}/sigla`, {
      sigla,
      corSigla,
    });
    return response.data;
  },

  async editarTitulo(acaoId, titulo) {
    const response = await api.put(`/acoes/${acaoId}/titulo`, { titulo });
    return response.data;
  },

  async editarAcao(acaoId, dados) {
    const response = await api.put(`/acoes/${acaoId}`, dados);
    return response.data;
  },

  async getIndiceDeCarga(acaoId, carga) {
    const response = await api.get(`/acoes/membros-carga/${acaoId}`, {
      params: { cargaAtividade: carga },
    });
    return response.data;
  },

  async enviarEmailCoordenador(acaoId, assunto, mensagem, emailCoordenador) {
    const response = await api.post(
      `/acoes/${acaoId}/enviar-email-coordenador`,
      {
        assunto,
        mensagem,
        emailCoordenador,
      }
    );
    return response.data;
  },

  async atualizarCurricularizada(acaoId, curricularizada) {
    const response = await api.patch(`/acoes/${acaoId}/curricularizada`, {
      curricularizada,
    });
    return response.data;
  },

  async getAcoesCurricularizadas(
    page = 0,
    size = 15,
    busca = "",
    isCurricularizada = null
  ) {
    const params = { page, size };
    if (busca && busca.trim()) {
      params.busca = busca.trim();
    }
    if (
      isCurricularizada !== null &&
      isCurricularizada !== undefined &&
      isCurricularizada !== ""
    ) {
      params.isCurricularizada = isCurricularizada;
    }
    const response = await apiPublic.get("/acoes-curricularizadas", { params });
    return response.data;
  },
};
